export default {
  welcome: 'Welcome',
  home: 'Home',
  'dashboard.title': 'Dashboard',
  'form.title': 'Form',
  'form.basic-form': 'Basic Form',
  'form.step-form.title': 'Step Form',
  'form.step-form.info': 'Step Form(write transfer information)',
  'form.step-form.confirm': 'Step Form(confirm transfer information)',
  'form.step-form.result': 'Step Form(finished)',
  'form.advanced-form': 'Advanced Form',
  'list.title': 'List',
  'list.table-list': 'Search Table',
  'list.basic-list': 'Basic List',
  'list.card-list': 'Card List',
  'list.search-list.title': 'Search List',
  'list.search-list.articles': 'Search List(articles)',
  'list.search-list.projects': 'Search List(projects)',
  'list.search-list.applications': 'Search List(applications)',
  'result.title': 'Result',
  'result.success': 'Success',
  'result.fail': 'Fail',
  'exception.title': 'Exception',
  'exception.not-permission': '403',
  'exception.not-find': '404',
  'exception.server-error': '500',
  'exception.trigger': 'Trigger',
  'account.title': 'Account',
  'account.center': 'Account Center',
  'account.settings': 'Account Settings',
  'account.trigger': 'Trigger Error',
  'account.logout': 'Logout',

  'user.management': 'User Management',
  'shop.title': 'Shop Management',
  'shop.shopMan': 'Shop Management',
  'shop.shopType': 'Shop Type',
  'material.title': 'Material Management',
  'material.index': 'Material List',
  'material.article.list': 'Article Management',
  'material.article.add': 'Add Article',
  'material.article.detail': 'Article Detail',
  'material.article.edit': 'Edit Article',
  'system.title': 'System',
  'system.character': 'Character',
  'system.member': 'Member',
  'system.company': 'Company',
  'system.systemLog': 'SystemLog',
  'system.dictionary': 'Dictionary',
  'system.memberUpload': 'MemberUpload',
  'quotation.title': 'Quotation Management',
  'quotation.model': 'Quotation Model',
  'quotation.record': 'Quotation Record',
  'quotation.recordDetail': 'Quotation RecordDetail',
  'consultation.management': 'Consultation Management',
  'consultation.add': 'Add Consultation',
  'consultation.detail': 'Consultation Detail',

  'ticket.management': 'Ticket Management',
  'ticket.add': 'Add Ticket',
  'ticket.edit': 'Edit Ticket',
  'ticket.detail': 'Ticket Detail',
  'ticket.session': 'Session Config',

  'order.management': 'Order Management',
  'order.detail': 'Order Detail',

  'artist.management': 'Artist Introduction',
  'artist.add': 'Add Artist',
  'artist.edit': 'Edit Artist'
}
